import { useState } from 'react';
import StartPage from './StartPage';
import DefineFieldsPage from './DefineFieldsPage';
import AnnotateDocumentPage from './AnnotateDocumentPage';
import ReviewPage from './ReviewPage';
import GeneratePdfPage from './GeneratePdfPage';
import { Box } from '@mui/material';

// Define the steps of the wizard with associated components
const steps = [
  {
    component: StartPage,
    key: 'start'
  },
  {
    component: DefineFieldsPage,
    key: 'fields'
  },
  {
    component: AnnotateDocumentPage,
    key: 'annotate'
  },
  {
    component: ReviewPage,
    key: 'review'
  },
  {
    component: GeneratePdfPage,
    key: 'generate'
  },
];

const Wizard = ({devMode, user}) => {
  const [step, setStep] = useState(0);

  const [projectData, setProjectData] = useState({
    title: 'Expense declaration',
    description: '',
    template: [
      { label: 'Date', type: 'date', useToday: true },
      { label: 'Description', type: 'string' },
      { label: 'Amount', type: 'decimal', sum: true }
    ],
    documents: [],
    signers: []
  });

  const [annotateIndex, setAnnotateIndex] = useState(undefined);

  const next = () => setStep(prev => Math.min(prev + 1, steps.length - 1));
  const back = () => setStep(prev => Math.max(prev - 1, 0));

  const goTo = (targetKey, index) => {
    const targetIndex = steps.findIndex(step => step.key === targetKey);
    if (targetIndex !== -1) {
      setStep(targetIndex);
      if (targetKey === 'annotate' && typeof index === 'number') {
        setAnnotateIndex(index);
      } else if (targetKey !== 'annotate') {
        setAnnotateIndex(undefined);
      }
    }
  };

  const updateProject = (updates) => {
    setProjectData(prev => ({ ...prev, ...updates }));
  };

  const StepComponent = steps[step].component;

  return (
    <Box
      px={{ xs: 2, sm: 4 }}
      py={{ xs: 3, sm: 5 }}
      sx={{ position: 'relative' }}
    >

      {/* Step content */}
      <StepComponent
        devMode={devMode}
        data={projectData}
        documents={projectData.documents}
        update={updateProject}
        onNext={next}
        onBack={back}
        onGoTo={goTo}
        {...(steps[step].key === 'annotate' && typeof annotateIndex === 'number'
          ? { currentIndex: annotateIndex }
          : {})}
        accessToken={user?.accessToken || null}
      />
    </Box>
  );
};

export default Wizard;
